<template>
	<div>
		<h1 v-text="isCompany ? '사업현황관리' : '사업비관리'">사업비관리</h1>
		<div class="search-bar web-hide">
			<input placeholder="검색" v-model="keywords" v-on:keyup.enter="searchKeyword" />
		</div>
		<div class="basic-container">
			<div>
				<div class="tool-box mobile-hide">
					<div class="search-bar">
						<input placeholder="검색" v-model="keywords" v-on:keyup.enter="searchKeyword" />
					</div>
					<div class="selectbox-area mobile-hide">
						<div class="select-wrapper cols-shot">
							<select v-model="businessYear">
								<option value="0">사업연도</option>
								<option v-for="(codeVO, i) in groupByBusinessYearList" :key="'groupByBusinessYearList_' + i" :value="codeVO.businessYear"
									>{{ codeVO.businessYear }}년</option
								>
							</select>
						</div>
						<div class="select-wrapper cols-shot">
							<select v-model="businessTp">
								<option value="" selected>소속TP</option>
								<option v-for="(codeVO, i) in businessYearByTpList" :key="'businessYearByTpList_' + i" :value="codeVO.businessTp"
									>{{ codeVO.businessTpNm }}TP</option
								>
							</select>
						</div>
						<div class="select-wrapper cols-middle">
							<select v-model="programCode">
								<option value="" selected>프로그램</option>
								<option v-for="(codeVO, i) in programCodeList" :key="'programCodeList' + i" :value="codeVO.programCode">{{
									codeVO.programName
								}}</option>
							</select>
						</div>
					</div>
				</div>
				<section class="table-area">
					<div class="table-header mobile-hide" ref="table">
						<div class="col-no">번호</div>
						<div class="col-date">연도</div>
						<div class="col-auto">소속TP</div>
						<div class="col-auto">새싹기업명</div>
						<div class="col-auto">프로그램명</div>
						<div class="col-state">선금</div>
						<div class="col-state">잔금</div>
					</div>
					<!--   wdb   -->
					<article class="table-list mobile-hide" v-for="(item, i) in businessList" v-bind:key="'businessList_' + i">
						<div class="col-no mobile-hide">{{ totalCount - (listPage - 1) * listPageRow - i }}</div>
						<div class="col-date">{{ item.businessYear }}</div>
						<div class="col-auto">
							<a @click="moveDetail(item.seqNo)"> {{ item.businessTpNm }}TP </a>
						</div>
						<div class="col-auto">
							<a @click="moveDetail(item.seqNo)">
								<v-clamp :max-lines="1" autoresize :expanded="isTableResize" v-text="item.companyNmKor">기업명/마케터명</v-clamp>
							</a>
						</div>
						<div class="col-auto mobile-hide">
							<a @click="moveDetail(item.seqNo)">
								{{ item.programNm }}
							</a>
						</div>
						<div class="col-state font-bold">
							<span v-if="item.programFirstFeeState === 'REFUND'" class="color-red">환불</span>
							<span v-else-if="item.programFirstFeeState === 'EXPAND'" class="color-shineGray">지급대기</span>
							<span v-else-if="item.programFirstFeeState === 'NOT_PAY'" class="color-shineGray">지급없음</span>
							<span v-else-if="item.programFirstFeeState === 'APPROVING'" class="color-yellow">승인중</span>
							<span v-else-if="item.programFirstFeeState === 'COMPLATE'" class="color-blue">지급완료</span>
							<span v-else>-</span>
						</div>
						<div class="col-state font-bold">
							<span v-if="item.programEndFeeState === 'REFUND'" class="color-red">환불</span>
							<span v-else-if="item.programEndFeeState === 'EXPAND'" class="color-shineGray">지급대기</span>
							<span v-else-if="item.programEndFeeState === 'NOT_PAY'" class="color-shineGray">지급없음</span>
							<span v-else-if="item.programEndFeeState === 'APPROVING'" class="color-yellow">승인중</span>
							<span v-else-if="item.programEndFeeState === 'COMPLATE'" class="color-blue">지급완료</span>
							<span v-else>-</span>
						</div>
					</article>

					<!--   mobile   -->
					<article class="table-list web-hide" v-for="(item, i) in businessList" v-bind:key="item.seqNo">
						<div class="col-no mobile-hide">{{ totalCount - (listPage - 1) * listPageRow - i }}</div>
						<div class="col-title">
							<a @click="moveDetail(item.seqNo)">{{ item.programNm }}</a>
						</div>
						<div class="col-date col-line">
							<a @click="moveDetail(item.seqNo)">{{ item.businessYear }}</a>
						</div>
						<div class="col-auto col-line">
							<a @click="moveDetail(item.seqNo)">{{ item.businessTpNm }}TP</a>
						</div>
						<div class="col-auto">
							<a @click="moveDetail(item.seqNo)">
								<v-clamp :max-lines="1" autoresize :expanded="isTableResize" v-text="item.companyNmKor">기업명/마케터명</v-clamp>
							</a>
						</div>
						<div class="col-state mobile-hide">
							<span v-if="item.programFirstFeeState === 'REFUND'" class="color-red">환불</span>
							<span v-else-if="item.programFirstFeeState === 'EXPAND'" class="color-shineGray">지급대기</span>
							<span v-else-if="item.programFirstFeeState === 'NOT_PAY'" class="color-shineGray">지급없음</span>
							<span v-else-if="item.programFirstFeeState === 'APPROVING'" class="color-yellow">승인중</span>
							<span v-else-if="item.programFirstFeeState === 'COMPLATE'" class="color-blue">지급완료</span>
							<span v-else>-</span>
						</div>
						<div class="col-state mobile-hide">
							<span v-if="item.programEndFeeState === 'REFUND'" class="color-red">환불</span>
							<span v-else-if="item.programEndFeeState === 'EXPAND'" class="color-shineGray">지급대기</span>
							<span v-else-if="item.programEndFeeState === 'NOT_PAY'" class="color-shineGray">지급없음</span>
							<span v-else-if="item.programEndFeeState === 'APPROVING'" class="color-yellow">승인중</span>
							<span v-else-if="item.programEndFeeState === 'COMPLATE'" class="color-blue">지급완료</span>
							<span v-else>-</span>
						</div>
					</article>
				</section>

				<paging :total-count="totalCount" :page="listPage" :rows="listPageRow" :click="pageClick" />
			</div>
		</div>
	</div>
</template>

<script>
import CONST from '@/constants';
import Paging from '@/components/common/Paging';

export default {
	title: '내비즈니스메인',
	name: 'MybusnessMain',
	props: [''],
	components: { Paging },
	data: function() {
		return {
			select: 1,
			isTableResize: false,
			colAutoWidth: 0,
			modalShow: false,
			loginMember: null,
			CONST,

			businessYear: 0,
			businessTp: '',
			programCode: '',

			keywords: '',
			listPage: 1,
			listPageRow: 10,
			businessList: [],
			totalCount: 0,

			groupByBusinessYearList: [],
			businessYearByTpList: [],
			programCodeList: [],
		};
	},
	watch: {
		businessYear: function() {
			// this.getBusinessYearByTpList();
			this.getBusinessFeeList();
		},
		businessTp: function() {
			this.getBusinessFeeList();
		},
		programCode: function() {
			this.getBusinessFeeList();
		},
	},
	created() {},
	mounted() {
		this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'FEE');
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
		// this.businessYear = this.$moment().format('YYYY');
		this.getGroupByBusinessYearList();
		this.getBusinessYearByTpList();
		this.getProgramCodeList();
		this.getBusinessFeeList();
	},
	beforeDestroy() {
		window.onresize = null;
	},
	computed: {
		isCompany: function() {
			return this.loginMember && this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY;
		},
	},
	methods: {
		moveDetail: function(seqNo) {
			//TODO 임시해제
			// if (!this.isCompany && approveFCd === 'STANDBY') {
			// 	alert('관리자 승인이 필요합니다.');
			// 	return false;
			// }
			this.$device.pushView('/mybusinessfee/detail/' + seqNo);
		},
		searchKeyword: function() {
			this.listPage = 1;
			this.getBusinessFeeList();
		},
		pageClick: function(p) {
			this.listPage = p;
			this.getBusinessFeeList();
		},
		getGroupByBusinessYearList: function() {
			let formData = new FormData();
			if (this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY) {
				formData.append('companySeqNo', this.loginMember.seqNo);
			} else {
				formData.append('userSeqNo', this.loginMember.seqNo);
			}
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/common/getGroupByBusinessYearList.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.groupByBusinessYearList = res.data.data;
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		getBusinessYearByTpList: function() {
			this.businessYearByTpList = [];
			this.businessTp = '';

			let formData = new FormData();
			if (this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY) {
				formData.append('companySeqNo', this.loginMember.seqNo);
			} else {
				formData.append('userSeqNo', this.loginMember.seqNo);
			}
			// formData.append('businessYear', this.businessYear);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/common/getBusinessYearByTpList.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.businessYearByTpList = res.data.data;
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		getProgramCodeList: function() {
			let formData = new FormData();
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/common/getProgramCodeList.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.programCodeList = res.data.data;
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		getBusinessFeeList: function() {
			this.businessList = [];
			this.totalCount = 0;
			let formData = new FormData();
			formData.append('userSeqNo', this.loginMember.seqNo);
			formData.append('businessYear', this.businessYear);
			formData.append('businessTp', this.businessTp);
			formData.append('programCode', this.programCode);
			formData.append('keywords', this.keywords);
			formData.append('page', this.listPage);
			formData.append('row', this.listPageRow);
			formData.append('orderType', 'companyNmKor');
			formData.append('listOrder', 'asc');
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/getBusinessFeeList.do', formData)
				.then(res => {
					if (res.data.resultCode !== 0) {
						window.alert(res.data.resultMsg);
					} else {
						this.businessList = res.data.data;
						this.totalCount = res.data.dataCount;
					}
				})
				.catch(e => {
					console.error(e);
					window.alert(e.message);
				});
		},
	},
};
</script>

<style scoped></style>
